module.exports = __webpack_public_path__ + "media/images/features/support/thumb-type-line-3c887da029711a9189263835d01cbb74.png";